var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146",
    transform: "translate(-1939 -7347)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(1939 7347)",
    fill: "#a61812"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M159.584,4.182a.72.72,0,0,0-.714.628l-.3,2.168h-.858a.72.72,0,0,0-.707.58l-.3,1.513h-.992a.72.72,0,0,0-.709.6l-.521,2.978,4.564-2.2h0a1.674,1.674,0,0,1,1.45,0L165.17,12.7l-.523-3.034a.72.72,0,0,0-.709-.6h-.992l-.3-1.513h0a.72.72,0,0,0-.707-.58h-.856l-.3-2.166a.72.72,0,0,0-.714-.628Z",
    transform: "translate(1796.177 7348.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M103.959,166.053l1.806,3.836h0a4.256,4.256,0,0,1,2.465-.737,4.338,4.338,0,0,1,2.6.825,1.362,1.362,0,0,0,.908.324h.013a1.357,1.357,0,0,0,.91-.322,4.338,4.338,0,0,1,2.6-.824,4.251,4.251,0,0,1,2.463.737l1.817-3.838a.944.944,0,0,0-.444-1.256l-6.977-3.349a.85.85,0,0,0-.737,0L104.4,164.8a.944.944,0,0,0-.444,1.256Z",
    transform: "translate(1844.251 7199.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M67.157,351.057a1.013,1.013,0,0,0-.977,1.285,1.023,1.023,0,0,0,.54.647,5.152,5.152,0,0,0,5.1-.456c.326-.209.339-.222.573-.222s.247,0,.578.224a5.138,5.138,0,0,0,5.885,0c.333-.209.339-.222.573-.222s.247,0,.575.222a5.157,5.157,0,0,0,5.1.456,1.017,1.017,0,0,0-.883-1.831,2.84,2.84,0,0,1-1.277.27,2.976,2.976,0,0,1-1.831-.6,2.846,2.846,0,0,0-3.371,0,2.976,2.976,0,0,1-1.821.594H75.9a2.98,2.98,0,0,1-1.823-.6,2.844,2.844,0,0,0-3.369,0,2.976,2.976,0,0,1-1.829.6,2.836,2.836,0,0,1-1.275-.268,1.02,1.02,0,0,0-.446-.1Z",
    transform: "translate(1880.088 7019.92)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/Ship.ea444abd.svg";
export { ForwardRef as ReactComponent };